import { completePhoneLists } from '@theme/hoxo-phone-pages';
import { Component } from '@theme/component';
class HoxoLifestyle extends Component {
  #abort;
  connectedCallback() {
    super.connectedCallback();
    this.#abort?.abort();
    this.#abort = new AbortController();
    const options = { signal: this.#abort.signal };
    const phoneForm = this.querySelector('[data-hl-phone-finder]');
    const accessoryForm = this.querySelector('[data-hl-accessory-finder]');
    const tabs = this.querySelectorAll('[data-hl-tab]');
    for (const tab of tabs) tab.addEventListener('click', () => {
      const phones = tab.dataset.hlTab === 'phones';
      phoneForm.hidden = !phones;
      accessoryForm.hidden = phones;
      for (const other of tabs) other.setAttribute('aria-pressed', String(other === tab));
    }, options);
    if (phoneForm) {
      const brand = phoneForm.querySelector('[data-hl-phone-brand]');
      const model = phoneForm.querySelector('[data-hl-phone-model]');
      let choices = [...model.options].map(option => option.cloneNode(true)).sort((a, b) => !a.value ? -1 : !b.value ? 1 : window.hoxoModelCompare ? window.hoxoModelCompare(a.textContent, b.textContent) : b.textContent.localeCompare(a.textContent, undefined, { numeric: true }));
      const updatePhones = () => {
        model.replaceChildren(...choices.filter(option => !option.value || !brand.value || option.dataset.brand === brand.value).map(option => option.cloneNode(true)));
      };
      brand.addEventListener('change', updatePhones, options);
      updatePhones();
      const loading = Boolean(model.dataset.hxNext);
      if (loading) brand.disabled = true;
      void completePhoneLists(phoneForm, this.#abort.signal).then(() => {
        if (options.signal.aborted) return;
        choices = [...model.options].map(option => option.cloneNode(true)).sort((a, b) => !a.value ? -1 : !b.value ? 1 : window.hoxoModelCompare ? window.hoxoModelCompare(a.textContent, b.textContent) : b.textContent.localeCompare(a.textContent, undefined, { numeric: true }));
        brand.disabled = false;
        updatePhones();
      });
      phoneForm.addEventListener('submit', event => {
        event.preventDefault();
        const url = new URL(model.value || phoneForm.action, window.location.origin);
        if (!model.value && brand.value) url.searchParams.set('filter.p.vendor', brand.value);
        window.location.assign(url.href);
      }, options);
    }
    if (accessoryForm) {
      const brand = accessoryForm.querySelector('[data-brand]');
      const model = accessoryForm.querySelector('[data-model]');
      const choices = [...model.options].map(option => option.cloneNode(true)).sort((a, b) => !a.value ? -1 : !b.value ? 1 : window.hoxoModelCompare ? window.hoxoModelCompare(a.textContent, b.textContent) : b.textContent.localeCompare(a.textContent, undefined, { numeric: true }));
      const update = () => {
        model.replaceChildren(...choices.filter(option => !option.value || option.dataset.brand === brand.value).map(option => option.cloneNode(true)));
        model.disabled = !brand.value;
      };
      brand.addEventListener('change', update, options);
      accessoryForm.addEventListener('submit', event => {
        const url = model.selectedOptions[0]?.dataset.url;
        if (url) { event.preventDefault(); window.location.assign(url); }
      }, options);
      update();
    }
  }
  disconnectedCallback() { this.#abort?.abort(); super.disconnectedCallback(); }
}
if (!customElements.get('hoxo-lifestyle')) customElements.define('hoxo-lifestyle', HoxoLifestyle);

